import { Button } from '@warp-ds/react';
import type { ReactNode } from 'react';

import styles from './Banner.module.css';

interface BannerContent {
    tagline?: string;
    header: string;
    text: string;
    callToAction: string;
    link: string;
    imgType: 'svg' | 'img';
    img?: {
        src: string;
        width: number;
        height: number;
        alt: string;
    };
    svg?: ReactNode;
    showShadow?: boolean;
}

export const Banner = ({ tagline, header, text, callToAction, link, imgType, img, svg, showShadow = true }: BannerContent) => (
    <section
        className={`flex flex-wrap flex-auto rounded-16 items-center justify-center mx-8 md:mx-0 md:flex-row-reverse md:flex-nowrap md:justify-between my-32 ${showShadow ? 'shadow-m' : ''}`}>
        {imgType === 'svg' ? (
            svg
        ) : (
            <div className={`w-full h-full overflow-hidden lg:rounded-lg ${styles.imgWrapper}`}>
                <img
                    className={`flex justify-center items-center text-center object-cover object-left min-w-full ${styles.img}`}
                    src={img?.src}
                    width={img?.width}
                    height={img?.height}
                    alt={img?.alt}
                />
            </div>
        )}
        <div className="p-32 lg:p-40 gap-y-16 lg:gap-y-20 text-center md:text-left w-full flex flex-col flex-auto justify-center items-center md:items-start">
            <div className="flex flex-col gap-y-8 md:gap-y-10">
                {tagline && <span className="s-text-subtle">{tagline}</span>}
                <h2>{header}</h2>
                <p>{text}</p>
            </div>
            <Button primary href={link} className="px-28 md:px-40">
                {callToAction}
            </Button>
        </div>
    </section>
);
